import React from 'react';
import {useFilter} from '@unthinkable/react-filters';
import {routeLink} from '../../../constant';
import {
  Container,
  FilterContainer,
  TaskTableContainer,
  TaskTablesContainer,
} from '../styles/TaskTable.style';
import {AutoCompleteFilter} from 'src/components/filter/Filters';
import {taskCategories} from '../task.config';
import {STATUS} from 'src/modules/user/constants/UserConstants';
import {TaskTable} from './TaskTable';
import {useAuth} from 'src/modules/auth/hooks/useAuth';

export const Task = () => {
  const {filterValues, onChangeFilter} = useFilter();
  const {user} = useAuth();
  return (
    <Container>
      <FilterContainer>
        <AutoCompleteFilter
          onChangeFilter={onChangeFilter}
          filterValues={filterValues}
          field={'residence'}
          filter={() => {
            return JSON.stringify({
              isRedoxFacility: false,
              status: STATUS.ACTIVE,
            });
          }}
          api={routeLink.getFacilities}
          key={'residenceFilter'}
          placeholder={'Residence'}
          suggestionField={'name'}
          sort={{name: 1}}
        />
      </FilterContainer>
      <TaskTablesContainer>
        {taskCategories(user).map((category, index) => {
          return (
            <TaskTableContainer key={index}>
              <TaskTable
                {...category}
                addOnFilter={JSON.stringify(filterValues.filter)}
              />
            </TaskTableContainer>
          );
        })}
      </TaskTablesContainer>
    </Container>
  );
};
